<div
  class="flex flex-col gap-3 bg-white items-center max-h-[80vh] overflow-y-auto z-49 relative"
>
  <div class="flex gap-2 w-full">
    <div class="flex-1 m-auto">
      <input
        type="search"
        name="search"
        [value]="currentInputValue"
        [disabled]="resultLoading()"
        (input)="onInputChange($event)"
        (keydown)="onKeyDown($event)"
        [placeholder]="'components.searchBar.placeholder' | transloco"
        class="border-1 border-vinciLavender rounded-lg p-2 font-light w-full text-[0.875rem] disabled:opacity-50 disabled:cursor-not-allowed"
      />
    </div>
    <app-button
      [text]="(resultLoading() ? 'components.searchBar.buttonTextWhenLoading' : 'components.searchBar.buttonText') | transloco"
      [variant]="'secondary'"
      [icon]="'glass'"
      [iconSize]="'1.25rem'"
      [disabled]="resultLoading() || !currentInputValue.trim()"
      (buttonClick)="onSearch()"
    ></app-button>
  </div>
  @if(resultLoading()){
  <loader class="my-10" />
  } @else {
  <div
    class="flex flex-col gap-2 divide-y divide-vinciLavender self-start w-full"
  >
    @if(tiles().length !== 0 ){
    <div class="flex flex-col gap-2 py-2">
      <p
        class="!font-bold hover:cursor-pointer self-start flex gap-2 items-center px-2 py-1 rounded-lg hover:bg-vinciLavender transition-colors duration-300 {{showTiles() ? 'bg-vinciLavender' : ''}}"
        (click)="showTiles.set(!showTiles())"
      >
        {{ 'components.searchBar.tilesSectionTitle' | transloco }}
        ({{tiles().length}})
        <icon
          [name]="showTiles() ? 'nav-arrow-up' : 'nav-arrow-down'"
          [size]="'0.875rem'"
        ></icon>
      </p>
      @if(showTiles()){
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        @for (tile of tiles(); track $index) {
        <app-tile
          [title]="tile.title"
          [text]="tile.text"
          [image]="tile.image"
          [ctaLink]="tile.ctaLink"
          [ctaText]="tile.ctaText | transloco"
          [isRedirectionExternal]="tile.isExternalLink"
          [variant]="$index % 4 === 0 ? 'secondary' : $index % 4 === 1 ? 'quaternary' : $index % 4 === 2 ? 'quinary' : 'tertiary'"
          class="!rounded-lg"
          (click)="onTileClick(tile)"
        ></app-tile>
        }
      </div>
      }
    </div>
    } @if(videos().length !== 0 ){
    <div class="flex flex-col gap-2">
      <p
        class="!font-bold hover:cursor-pointer self-start flex gap-2 items-center px-2 py-1 rounded-lg hover:bg-vinciLavender transition-colors duration-300 {{showVideos() ? 'bg-vinciLavender' : ''}}"
        (click)="showVideos.set(!showVideos())"
      >
        {{ 'components.searchBar.videosSectionTitle' | transloco }}
        ({{videos().length}})
        <icon
          [name]="showVideos() ? 'nav-arrow-up' : 'nav-arrow-down'"
          [size]="'0.875rem'"
        ></icon>
      </p>
      @if(showVideos()){
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        @for (video of videos(); track $index) {
        <app-card-result
          [id]="video.id"
          [title]="video.title"
          [text]="video.text"
          [image]="video.base64Image"
          [link]="video.link"
          [variant]="$index % 4 === 0 ? 'quinary' : $index % 4 === 1 ? 'secondary' : $index % 4 === 2 ? 'tertiary' : 'quaternary'"
          [isRedirectionExternal]="video.isExternalLink"
          [modalTextDisclaimer]="video.textDisclaimer"
          (click)="onVideoClick(video)"
        ></app-card-result>
        }
      </div>
      }
    </div>

    } @if(rhContacts().length !== 0 ){
    <div class="flex flex-col gap-2">
      <p
        class="!font-bold hover:cursor-pointer self-start flex gap-2 items-center px-2 py-1 rounded-lg hover:bg-vinciLavender transition-colors duration-300 {{showRhContacts() ? 'bg-vinciLavender' : ''}}"
        (click)="showRhContacts.set(!showRhContacts())"
      >
        {{ 'personalizedJourney.hrContactExchange.title' | transloco }}
        ({{rhContacts().length}})
        <icon
          [name]="showRhContacts() ? 'nav-arrow-up' : 'nav-arrow-down'"
          [size]="'0.875rem'"
        ></icon>
      </p>
      @if(showRhContacts()){
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        @for (rhContact of rhContacts(); track $index) {
        <app-contact-card
          [spId]="rhContact.spId || 0"
          [name]="rhContact.firstName + ' ' + rhContact.lastName"
          [job]="rhContact.job"
          [entity]="rhContact.entity"
          [mail]="rhContact.mail"
          [bookingLink]="rhContact.bookingCalendarLink"
        ></app-contact-card>
        }
      </div>
      }
    </div>

    } @if(mobilityContacts().length !== 0 ){
    <div class="flex flex-col gap-2">
      <p
        class="!font-bold hover:cursor-pointer self-start flex gap-2 items-center px-2 py-1 rounded-lg hover:bg-vinciLavender transition-colors duration-300 {{showMobilityContacts() ? 'bg-vinciLavender' : ''}}"
        (click)="showMobilityContacts.set(!showMobilityContacts())"
      >
        {{ 'personalizedJourney.exchange.myMobilityRefs' | transloco }}
        ({{mobilityContacts().length}})
        <icon
          [name]="showMobilityContacts() ? 'nav-arrow-up' : 'nav-arrow-down'"
          [size]="'0.875rem'"
        ></icon>
      </p>
      @if(showMobilityContacts()){
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        @for (mobilityRef of mobilityContacts(); track $index) {
        <app-contact-card
          [spId]="mobilityRef.spId"
          [name]="mobilityRef.firstName + ' ' + mobilityRef.lastName"
          [job]="mobilityRef.job"
          [mail]="mobilityRef.mail"
          [phoneNumber]="mobilityRef.phoneNumber"
          [languages]="mobilityRef.languages"
          [location]="mobilityRef.location"
          [bookingLink]="mobilityRef.bookingCalendarLink"
        ></app-contact-card>
        }
      </div>
      }
    </div>

    } @if(tiles().length === 0 && videos().length === 0 && rhContacts().length === 0 && mobilityContacts().length === 0 && userHasSearched() ){
    <p class="text-vinciGray text-center">
      {{ 'components.searchBar.noResult' | transloco }}
    </p>
    }
  </div>
  }
</div>
